// material ui
import { useMediaQuery, useTheme as useMuiTheme } from '@mui/material';

const useResponsiveChartHeight = () => {
  const muiTheme = useMuiTheme();
  const isLgUp = useMediaQuery(muiTheme.breakpoints.up('lg'));

  return isLgUp ? 600 : 400;
};

export default useResponsiveChartHeight;
